import React from 'react';
import classNames from 'classnames';
import ValidationMixin from 'validations/validation-mixin';

const BASE_CLASS = 'eas-combobox';

var DropDown = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    collection: React.PropTypes.array.isRequired,
    value: React.PropTypes.string,
    placeholder: React.PropTypes.object,
    onChange: React.PropTypes.func,
    disabled: React.PropTypes.bool,
    isNotValid: React.PropTypes.bool
  },
  onChange(e){
    var value = e.target.value;
    if (this.props.onChange)
      this.props.onChange(e, value);
  },
  getClass() {
    return classNames(
      BASE_CLASS,
      {
        disabled: this.props.disabled
      },
      this.props.className);
  },
  render: require('./drop-down.rt')
});

module.exports = ValidationMixin(DropDown);


/** WEBPACK FOOTER **
 ** ./src/form-controls/drop-downs/drop-down/index.js
 **/